import { Grid, Text } from '@mantine/core'
import { Member } from '@ospace/schemas'

import { MemberBox } from './MemberBox'

export const MemberList = ({ teamMembers }: { teamMembers: Member[] }) => {
  return (
    <Grid
      gutter={'xl'}
      style={{
        minHeight: ' calc(100vh - 190px)',
      }}
    >
      {teamMembers.length > 0 ? (
        teamMembers.map((team: any) => (
          <Grid.Col
            span={{
              base: 12,
              md: 4,
            }}
          >
            <MemberBox user={team} />
          </Grid.Col>
        ))
      ) : (
        <Text>No team members assigned yet!</Text>
      )}
    </Grid>
  )
}
